import React from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  Grid,
  Typography,
} from '@material-ui/core';




const useStyles = makeStyles(theme => ({
  nestedHead: {
    paddingLeft: theme.spacing(4),
  },
  nested: {
    paddingLeft: theme.spacing(6),
  },
  weekend: {
    backgroundColor: '#e0f2f1'
  }
}));

const MealCounter = props => {
  const { conter, name } = props;
  const classes = useStyles();

  // useEffect(() => {
  //   // console.log('Day useEffect', date, weekend, props.checked)
  //   // setOpen(props.session.open);
  //   setChecked(props.checked)
  // }, [props.checked]);

  
  // const [checked, setChecked] = useState(
  //   props.checked
  //  )

 
  return (
<Card
      // {...rest}
      // className={clsx(classes.root, className)}

    >
      <CardContent>
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              {name}:
            </Typography>
            <Typography variant="h3">{conter}</Typography>
          </Grid>
        </Grid>
        {/* <div className={classes.difference}>
        <Chip label="Частично оплачен" size="small"/>
        </div> */}
      </CardContent>
    </Card>
    );
};


export default MealCounter;
